import { Selection } from 'd3';

interface D3Styles {
  'stroke-width'?: number;
  'pointer-events'?: string;
}

export function d3Style(
  params: Partial<CSSStyleDeclaration> | D3Styles,
  elm: Selection<SVGElement, unknown, null, unknown>
): void {
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      // @ts-ignore
      const styleVal = params[key];
      elm.style(key, styleVal);
    }
  }
}
